/**
 * Search Mode Reducer
 * Manages the state for automatic switching between Fast and Manual search modes
 */

export type SearchMode = 'fast' | 'manual';

export type SearchModeState = {
  mode: SearchMode;
};

export type SearchModeAction =
  | { type: 'SWITCH_TO_FAST' }
  | { type: 'SWITCH_TO_MANUAL' };

/**
 * Reducer function for search mode state management
 * @param state - Current search mode state
 * @param action - Action to dispatch
 * @returns New search mode state
 */
export const searchModeReducer = (
  state: SearchModeState,
  action: SearchModeAction,
): SearchModeState => {
  switch (action.type) {
    case 'SWITCH_TO_FAST':
      return { mode: 'fast' };
    case 'SWITCH_TO_MANUAL':
      return { mode: 'manual' };
    default:
      return state;
  }
};

/**
 * Initial state factory
 * @param initialMode - Optional initial mode (defaults to 'fast')
 * @returns Initial search mode state
 */
export const createInitialState = (
  initialMode: SearchMode = 'fast',
): SearchModeState => ({
  mode: initialMode,
});
